import { render, staticRenderFns } from "./EditArticleCalculation.vue?vue&type=template&id=609c8979"
import script from "./EditArticleCalculation.vue?vue&type=script&lang=js"
export * from "./EditArticleCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports